<h1 mat-dialog-title class="p-2 text-center" i18n>Ajout d'une limite </h1>
<div mat-dialog-content class="p-3">
    <!-- <mat-slide-toggle class="my-3" [(ngModel)]="Model.IsActive">Actif!</mat-slide-toggle> -->
    <div class="row align-items-center">
        <div class="col-6">
            <mat-form-field class="w-100">
                <input matInput [(ngModel)]="Model.Code" i18n-placeholder placeholder="Code" readonly>
            </mat-form-field>
        </div>

        <div class="col-6">
            <mat-form-field class="w-100">
                <mat-select i18n-placeholder placeholder="Jeu de limite" [(ngModel)]="Model.Name">
                    @for (cat of CategoryList; track cat.Code; let i = $index) {
                    <mat-option [value]="cat.Name">
                        {{ cat.Name }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

    </div>
    <div class="row">

        <div class="col-auto">
            <mat-form-field class="">
                <mat-select i18n-placeholder placeholder="Type 1" [(ngModel)]="Model.Type1">
                    @for (lq of LimitValueTypeList; track lq; let i = $index) {
                    <mat-option [value]="i + 1">
                        {{ lq }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col">
            <mat-form-field class="w-100">
                <input matInput type="number" [(ngModel)]="Model.Value1" i18n-placeholder placeholder="Valeur 1" required>
            </mat-form-field>
        </div>
    </div>

    <div class="row">
        <div class="col-auto">
            <mat-form-field class="">
                <mat-select i18n-placeholder placeholder="Type 2" [(ngModel)]="Model.Type2">
                    @for (lq of LimitValueTypeList; track lq; let i = $index) {
                    <mat-option [value]="i + 1">
                        {{ lq }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col">
            <mat-form-field class="w-100">
                <input matInput type="number" [(ngModel)]="Model.Value2" i18n-placeholder placeholder="Valeur 2" required>
            </mat-form-field>
        </div>
    </div>
    <!-- <div class="row">
        <div class="col">
            <mat-form-field class="w-100">
                <input matInput type="number" [(ngModel)]="Model.Multiplier" placeholder="Multiplicateur de LQ" required>
            </mat-form-field>
        </div>
    </div> -->
    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()" i18n>
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1 white" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!CanSave()" i18n>
            {{ IsCreation ? 'Ajouter' : 'Modifier' }}
        </button>
    </div>
</div>